import * as log from 'loglevel';

/*
 * The following functions can be used in vuex getters and mutations.
 * Only actions have access to vuex getters, therefore these are necessary to not
 * repeat the getter-code all the time.
 */

/**
 * @param {Object} state
 */
function getActiveSide(state) {
  return state.card.sides.find(c => c.id === state.tmp.activeSideId);
}

function getSideById(state, sideId) {
  return state.card.sides.find(c => c.id === sideId);
}

/**
 * @param {Object} state
 */
function getActiveTheme(state) {
  // TODO: Needs change in Templatedesigner, there must always be exatcly
  // one theme which is active
  // return state.card.themes.find(t => t.isActive === true);
  return state.card.themes.find(theme => theme.id === state.card.activeThemeId);
}

/**
 * @param {Object} state
 */
function getActiveLayer(state) {
  const side = getActiveSide(state);
  if (!side) { return null; }
  return side.layers.find(l => l.id === state.tmp.activeLayerId);
}

/**
 * @param {Object} state
 */
function getActiveLayerId(state) {
  return state.tmp.activeLayerId;
}

function getLayerBySideIdAndLayerId(state, { sideId, layerId }) {
  const side = getSideById(state, sideId);
  if (!side) {
    log.error('Could not find side with ID: ', sideId);
    return null;
  }
  if (!side.layers) {
    log.error(`Side ${sideId} has no layers`);
    return null;
  }
  const layer = side.layers.find(l => l.id === layerId);
  if (!layer) { log.error(`Side ${sideId} has no layer with ID`); }
  return layer;
}

export default {
  getActiveSide,
  getActiveLayer,
  getActiveLayerId,
  getActiveTheme,
  getSideById,
  getLayerBySideIdAndLayerId,
};
